/** Board-style status for a submission card: pill copy + tone, and which list section it sits in. */
export type SubmissionTone = 'dark' | 'red' | 'grey' | 'green';
export type SubmissionGroup = 'todo' | 'review' | 'done';
export interface SubmissionCardStatus {
  pill: string;
  tone: SubmissionTone;
  group: SubmissionGroup;
}

const REMOVED: SubmissionCardStatus = { pill: 'Removed', tone: 'grey', group: 'done' };
const APPROVED: SubmissionCardStatus = { pill: 'Approved', tone: 'green', group: 'done' };
const EDITS: SubmissionCardStatus = { pill: 'Edits requested', tone: 'red', group: 'todo' };

/** Post deliverable slot (`deliverableLinks[key][i]`). `needsEdits` = `linkNeedsEdits(link)`. */
export function deliverableCardStatus(
  status: string,
  opts: { voided?: boolean; needsEdits?: boolean; isStory?: boolean } = {},
): SubmissionCardStatus {
  if (opts.voided) return REMOVED;
  if (opts.needsEdits) return EDITS;
  switch (status) {
    case 'approved':
      return APPROVED;
    case 'pendingDraftReview':
      return { pill: 'In review', tone: 'grey', group: 'review' };
    case 'pendingVerification':
      return { pill: 'Link in review', tone: 'grey', group: 'review' };
    case 'pendingDraftSubmission':
      return { pill: 'Draft due', tone: 'dark', group: 'todo' };
    case 'pendingSubmission':
    default:
      return { pill: opts.isStory ? 'Story due' : 'Post due', tone: 'dark', group: 'todo' };
  }
}

/** UGC requirement group, keyed by `getEffectiveContentStatus` (or 'voided'). */
export function contentCardStatus(status: string): SubmissionCardStatus {
  switch (status) {
    case 'voided':
      return REMOVED;
    case 'approved':
      return APPROVED;
    case 'pendingVerification':
      return { pill: 'In review', tone: 'grey', group: 'review' };
    case 'linkPendingVerification':
      return { pill: 'Link in review', tone: 'grey', group: 'review' };
    case 'contentRejected':
      return { pill: 'Revision', tone: 'red', group: 'todo' };
    case 'linkNeedsEdit':
      return EDITS;
    case 'linkPendingSubmission':
      return { pill: 'Links due', tone: 'dark', group: 'todo' };
    case 'pendingSubmission':
    default:
      return { pill: 'To upload', tone: 'dark', group: 'todo' };
  }
}

export const SUBMISSION_GROUPS: { key: SubmissionGroup; title: string }[] = [
  { key: 'todo', title: 'To do' },
  { key: 'review', title: 'In review' },
  { key: 'done', title: 'Done' },
];
